import React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SectionTwoBlockMySoftwareApps from "./SectionTwoBlockMySoftwareApps";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "3em 0",
    backgroundColor: theme.palette.colors.lightBlue,
    color: theme.palette.colors.black,
  },
}));

function SectionTwoMySoftwareApps() {
  const classes = useStyles();

  return (
    <Grid className={classes.root} container>
      <SectionTwoBlockMySoftwareApps heading="Help Desk App" />
      <SectionTwoBlockMySoftwareApps
        heading="Project Tracker"
        imageSrc="https://picsum.photos/id/2/300/300"
      />
      <SectionTwoBlockMySoftwareApps text="much less text. keep the text content similar for best alignment. we're using 'flex-start' to keep the top of each cell aligned." />
    </Grid>
  );
}

export default SectionTwoMySoftwareApps;
